import VueCookie from 'vue-cookie';
import i18n from '../i18n';
import { locales } from '../helpers/locales';

const NotFound = () => import('@/views/not-found');
const Disclaimer = () => import('@/views/disclaimer');
const LaunchPad = () => import('@/views/launchpad');
const Staking = () => import('@/views/launchpad/staking');
const StakeSelect = () => import('@/views/launchpad/stakeselect');
const TokenSale = () => import('@/views/launchpad/tokensale');
const Claim = () => import('@/views/launchpad/claim');
const LaunchAgreement = () => import('@/views/launchpad/agreement');
const Calendar = () => import('@/views/launchpad/calendar');
// const Maintenance = () => import('@/views/maintenance');

export default [
  {
    path: '/disclaimer',
    name: 'disclaimer',
    component: Disclaimer,
    meta: {
      backTo: '/',
      withoutAuth: true,
    },
  },
  {
    path: '/',
    name: 'launchpad',
    component: LaunchPad,
    meta: {
      withoutAuth: true,
    },
  },
  {
    path: '/launchpad/agreement',
    name: 'agreement',
    component: LaunchAgreement,
    meta: {
      backTo: '/',
      withoutAuth: true,
    },
  },
  {
    path: '/staking/:pid',
    name: 'staking',
    component: Staking,
    meta: {
      backTo: '/staking',
    },
  },
  {
    path: '/staking',
    name: 'stakeselect',
    component: StakeSelect,
    meta: {
      backTo: '/',
      withoutAuth: true,
    },
  },
  {
    path: '/tokensale/:pid',
    name: 'tokensale',
    component: TokenSale,
    meta: {
      backTo: '/',
    },
  },
  {
    path: '/claim/:pid',
    name: 'claim',
    component: Claim,
    meta: {
      backTo: '/',
    },
  },
  {
    path: '/calendar',
    name: 'calendar',
    component: Calendar,
    meta: {
      backTo: '/',
      withoutAuth: true,
    },
  },
  {
    path: '/not-found',
    alias: '*',
    name: '404',
    component: NotFound,
  },
  {
    path: '/:lang',
    component: NotFound,
    beforeEnter(to, from, next) {
      const {
        params: { lang },
      } = to;
      if (!locales.includes(lang)) {
        return next();
      }
      if (i18n.locale !== lang) {
        i18n.locale = lang;
        VueCookie.set('locale', lang);
      }
      return next('/');
    },
  },
];
